class HomepageHeader {
  constructor() {
    this.header = document.querySelector('[data-homepage-header]');
    if (!this.header) return;

    this.menuToggle = this.header.querySelector('[data-menu-toggle]');
    this.menu = this.header.querySelector('[data-menu]');
    this.menuRhs = this.header.querySelector('[data-menu-rhs]');
    this.body = document.body;

    if (!this.menuToggle || !this.menu) return;

    this.init();
  }

  init() {
    this.menuToggle.addEventListener('click', () => this.toggleMenu());
    
    // Close menu when clicking outside or on a menu link
    this.menu.addEventListener('click', (e) => {
      if (e.target.classList.contains('homepage-header__menu-link')) {
        this.closeMenu();
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isMenuOpen()) {
        this.closeMenu();
      }
    });
  }

  toggleMenu() {
    if (this.isMenuOpen()) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.menuToggle.setAttribute('aria-expanded', 'true');
    this.menu.classList.add('is-open');
    if (this.menuRhs) {
      this.menuRhs.classList.add('is-open');
    }
    this.body.classList.add('menu-open');
    if (typeof window.disableTouchScroll === 'function') {
      window.disableTouchScroll(this.menu);
    }
  }

  closeMenu() {
    this.menuToggle.setAttribute('aria-expanded', 'false');
    this.menu.classList.remove('is-open');
    if (this.menuRhs) {
      this.menuRhs.classList.remove('is-open');
    }
    this.body.classList.remove('menu-open');
    if (typeof window.enableTouchScroll === 'function') {
      window.enableTouchScroll();
    }
  }

  isMenuOpen() {
    return this.menu.classList.contains('is-open');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HomepageHeader();
  });
} else {
  new HomepageHeader();
}
